import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {camelizeKeys, decamelizeKeys} from 'humps'
import {useSelector} from 'react-redux'

export const hourRankList = createAsyncThunk(
  '/live/activity/auction_homepage',
  async (arg, store) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/activity/auction_homepage',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

// [购买礼物](https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17577824)
export const buyPromotion = createAsyncThunk(
  '/live/activity/auction_buy',
  async ({goodList}: any, store) => {
    const resp = await http.post('/live/activity/auction_buy', {
      ...store.getState().env.deviceinfo,
      good_list: decamelizeKeys(goodList),
    })
    return camelizeKeys(resp.data)
  }
)

export enum AuctionStatusEnum {
  over = 2,
  notStarted = 1,
  ongoing = 0,
}

interface InitialStateType {
  // 礼物数据
  gift_list?: Array<{
    good_id: number
    name: string
    cur_price: number
    price: number
    show_url: string
    url: string
    vfx_reward: boolean
    // 数量
    goodsNum: number
  }>
  // ---动态头图----
  // 头图礼物图片
  picture_list?: Array<string>
  // 倒计时
  remain_seconds?: number
  // 活动日期
  date?: string
}

const initialState: InitialStateType = {}

export const LuxuryCarFairSlice = createSlice({
  name: 'LuxuryCarFair',
  initialState,
  reducers: {
    changeGoodNum: (state, action) => {
      const data = action.payload
      Object.assign(state, {
        gift_list: state.gift_list.map((item, index) => {
          let {goodsNum} = item
          if (item.good_id === data.good_id) {
            if (data.status === 'add') {
              if (item.goodsNum < 200) {
                goodsNum += 1
              }
            } else if (item.goodsNum > 0) {
              goodsNum -= 1
            }
          }
          return {
            ...item,
            goodsNum,
          }
        }),
      })
    },
    GIFT_LIST_RESET: (state) => {
      // 购买成功后清空购物车
      Object.assign(state, {
        gift_list: state.gift_list.map((item, index) => {
          const goodsNum = 0
          return {
            ...item,
            goodsNum,
          }
        }),
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(hourRankList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {
        ...data,
        gift_list: data.gift_list.map((item, index) => {
          const goodsNum = 0
          return {
            ...item,
            goodsNum,
          }
        }),
      })
    })
  },
})
export default LuxuryCarFairSlice.reducer
export const useLuxuryCarFairState = () => {
  const data = useSelector((state) => state.LuxuryCarFair)
  return data
}
